import { getRequest } from '../services/requestHandler';
import { IronClub } from '../models';

export const getIronClubs = async () => {
  const url = 'ironClub/getironclubs?activeOnly=true';
  const response = await getRequest<IronClub>('getIronClubs', url);
  return response;
};
